package uz.ferro.shop.ui.productgroup

import mui.material.Box
import mui.material.Grid
import mui.system.Breakpoint
import mui.system.responsive
import mui.system.sx
import react.FC
import uz.ferro.shop.pages.product.ProductItemView
import uz.ferro.shop.ui.AppTextBold
import uz.ferro.shop.util.lg
import uz.ferro.shop.util.md
import uz.ferro.shop.util.xs
import web.cssom.pct
import web.cssom.px

val ProductGroupProductsVerticalView = FC<ProductGroupViewProps> { props ->
    val products = props.productGroup.products.orEmpty().mapNotNull { it.product }
    Box {
        AppTextBold {
            sx {
                width = 100.pct
                fontSize = responsive(
                    Breakpoint.xs to 16.px,
                    Breakpoint.md to 25.px
                )
            }
            text = props.productGroup.getLocalizedName()
        }

        Box {
            sx {
                height = 16.px
            }
        }

        Grid {
            container = true
            spacing = responsive(12.px)

            products.forEach { product -> Grid {
                    item = true
                    xs = 6
                    md = 4
                    lg = 3

                    ProductItemView {
                        this.product = product
                    }
                }
            }
        }
    }
}